// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__xs-cM","body":"Dashboard_body__CQqVJ"};